import request from '@/utils/request';
import {
  setStore,
  getStore,
} from '@/utils/store'
const projectName = '/api/blade-platform';

const backlog = {
    state: {

    },
    mutations: {

    },
    actions: {
        //保存接口
        serviceItemUpdate(actions, data) {
            return request({
                url: `${projectName}/serviceItem/update`,
                method: 'post',
                data
            })
        },

    }
}
export default backlog
